/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import { useState, useEffect } from 'react';
import { RouteObject, Routes, Route } from 'react-router-dom';
import { DraftApplicationsPage } from './navigation';
import { SidebarWidget } from '@widgets/sidebar-widget-react';
import { vappContainer, VApplication } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { useNavigate } from 'react-router-dom';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { toast } from 'react-hot-toast';
import { DraftAppPageService } from './services';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { GET_APPLICATION_COUNT } from '@/AppNavigator/services/graphql';

let currentPath = '';

const getAppNavService = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

const getSrv = () => {
  return vappContainer.get<DraftAppPageService>(
    DraftAppPageService.displayName
  );
};

export const getDraftPageRoute = (props: any): RouteObject | any => {
  const srv = getAppNavService();
  const storageSrv = StorageModule?.getInstance();
  const [notification, setNotification] = useState(props?.items);
  const [countData, setCountData] = useState({
    draftApp: null,
    pendingPaymentApp: null,
    missingInfo: null
  });
  const navigate = useNavigate();

  useEffect(() => {
    console.log('useefffect1');
    let _path: any = window.location.href;
    _path = _path.split('/');
    _path.reverse();
    console.log(`path :`, _path[0]);
    if (_path[0] !== currentPath) {
      currentPath = _path[0];
      // Check if the current path is "/draft-application"
      if (currentPath === 'draft-applications') {
        console.log('useefffect2');
        updateNotifiation();
      }
    }
  });

  const _handleDropDownItemClick = (item: any) => {
    console.log(`id`, item?.id);
    if (item.id === 'logout') {
      storageSrv.reset('session');
      storageSrv.reset('local');
      navigate(`/`);
    } else {
      toast.success('Coming soon!');
    }
  };
  console.log('inside Draft route', props);

  const updateBadgesByIds = (data: any, updates: any) => {
    return data.map((item: any) => {
      const update = updates.find((update: any) => update.id === item.id);

      if (update) {
        return {
          ...item,
          badgeText: update.badgeText,
          badgeBg: update.badgeBg,
        };
      } else if (item.children) {
        return {
          ...item,
          children: updateBadgesByIds(item.children, updates),
        };
      }

      return item;
    });
  };

  let updates: any[] = [];

  const updateNotifiation = async () => {
    console.log('Sidebar #3 updateNotifiation->draft app');
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const userProfile = storageService.get('myProfile', 'session');
    const role = userProfile?.org?.orgRole;
    const roetable = [
      {
        column: 'type',
        op: 'In',
        value: ['CARICOM_NEW_WORK_PERMIT', 'CARICOM_RENEW_WORK_PERMIT'],
      },
    ];
    const whoAmI =
      userData?.currentRole ??
      (userData?.userRoles && Array.isArray(userData?.userRoles)
        ? userData?.userRoles[0]?.name
        : null);
    const client = gql.getClient();
    let updatedSideBarITems: any = [];
    try {
      if (client) {
        const draftStatusValue =
          whoAmI === 'prospective_employee'
            ? ['APPLICANT_DRAFT']
            : ['APPLICATION_INCOMPLETE', 'APPLICANT_DRAFT'];
        const paymentStatusValue =
          whoAmI === 'prospective_employee'
            ? ['READY_TO_PAY']
            : ['READY_TO_PAY', 'WAITING_FOR_WP_FEE'];
        const typeNotIn =
          whoAmI === 'prospective_employee'
            ? ['NEW_WORK_PERMIT', 'RENEW_WORK_PERMIT']
            : [
                'CSME_VERIFICATION',
                'NEW_CSME_CERTIFICATE',
                'RENEW_CSME_CERTIFICATE',
                'MARRIAGE_EXEMPTION',
              ];
        const res = await client.query(GET_APPLICATION_COUNT, {
          draftApp: {
            where: [
              ...(role === 'CARICOM_BUSSINESS_ORG' ? roetable : []),

              {
                column: 'status',
                value: draftStatusValue,
                op: 'In',
              },
            ],
          },
          pendingPaymentApp: {
            where: [
              ...(role === 'CARICOM_BUSSINESS_ORG' ? roetable : []),

              {
                column: 'status',
                op: 'In',
                value: paymentStatusValue,
              },
              {
                column: 'type',
                op: 'NotIn',
                value: typeNotIn,
              },
            ],
          },
          missingInfo: {
            where: [
              {
                column: 'status',
                op: 'In',
                value: [
                  "MISSING_INFORMATION", "DOCUMENTATION_REJECTED"
                ],
              }
            ],
          },
        });
        if (res?.data) {
          console.log(`getApplicationCount`, res?.data);
          if (
            res?.data?.draftApp !== countData?.draftApp ||
            res?.data?.pendingPaymentApp !== countData?.pendingPaymentApp ||
            res?.data?.missingInfo !== countData?.missingInfo
          ) {
            updates = [
              {
                id: 'DraftAppList',
                badgeText: res?.data?.draftApp,
                badgeBg: 'danger',
              },
              {
                id: 'PendingPayment',
                badgeText: res?.data?.pendingPaymentApp,
                badgeBg: 'danger',
              },
              {
                id: 'MissingInfo',
                badgeText: res?.data?.missingInfo,
                badgeBg: 'danger',
              },
            ];

            updatedSideBarITems = updateBadgesByIds(props?.items, updates);
            setCountData(res?.data);
            console.log(
              'Sidebar #4 updateNotifiation totalCount->',
              updatedSideBarITems
            );
            setNotification(updatedSideBarITems);
          }
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
    }
    console.log(
      'Sidebar #3 updateNotifiation totalCount->',
      updatedSideBarITems
    );
  };

  console.log(`Sidebar #2 Route updated data :`, notification);

  return {
    path: '/draft-applications',
    element: (
      <SidebarWidget
        {...props}
        notFoundLink={'/404'}
        {...props}
        component={DraftApplicationsPage}
        items={notification}
        abilityCheck={srv.abilityCheck.bind(
          null,
          props?.routes?.DraftApplication?.id,
          props?.whoami,
          'read'
        )}
      />
    ),
  };
};
